import './Tab.scss';

import React from 'react';
import { Link } from 'react-router';

export default class Tab extends React.Component {
    render() {
        let { className, to } = this.props;
        return (
            <Link className={`tab ${className}`}
                  to={to}>
                {this.props.children}
            </Link>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Tab/index.js